import React from "react";
import { ExternalLink, SfIcon } from "./Ui";
import { curateLabel, formatAmount } from "../utils";

const FIELD_LABELS = {
  Name: "Name",
  Website: "Website",
  FirstName: "First name",
  LastName: "Last name",
  Email: "Email",
  Title: "Title",
  StageName: "Stage",
  CloseDate: "Close date",
  OwnerId: "Owner",
  RecordTypeId: "Business line",
  LeadSource: "Lead source",
  Type: "Type",
  Curate_Category__c: "Curate category",
  P_L_Type__c: "P&L type",
  Summit_Event__c: "Summit event",
  NextStep: "Next step",
  Amount: "Amount",
  Description: "Description",
  Loss_Reason__c: "Loss reason",
  of_Custom_Events__c: "# of Curate events",
  LinkedIn__c: "LinkedIn",
  LID__LinkedIn_Company_Id__c: "LinkedIn company id",
  IsPrimary: "Primary",
  Role: "Role",
  Subject: "Subject",
  Status: "Status",
  ActivityDate: "Date",
};

const OPP_MODIFY_TYPES = ["update_opportunity", "close_opportunity"];

function statusLabel(action) {
  if (action.status === "applied") return action.type === "close_opportunity" ? "Closed" : action.type === "update_opportunity" ? "Updated" : "Created";
  if (action.status === "skipped") return action.type === "close_opportunity" ? "Already closed" : action.resultSfId ? "Existing" : "Skipped";
  if (action.status === "failed") return "Failed";
  return "Planned";
}

function statusTone(action) {
  if (action.status === "applied") return "success";
  if (action.status === "failed") return "danger";
  if (action.status === "skipped") return action.resultSfId ? "info" : "neutral";
  return "neutral";
}

export function describeValue(field, value, meta) {
  if (value === null || value === undefined || value === "") return "";
  if (field === "OwnerId" && meta && meta.owners) {
    const o = meta.owners.find((u) => u.sfUserId === value);
    return o ? o.name : value;
  }
  if (field === "RecordTypeId" && meta && meta.picklists) {
    const r = [...(meta.picklists.recordTypes || []), ...(meta.picklists.allRecordTypes || [])].find((x) => x.recordTypeId === value);
    return r ? r.name : value;
  }
  if (field === "Curate_Category__c") return curateLabel(value);
  if (field === "Summit_Event__c" && meta && meta.summitEvents) {
    const e = meta.summitEvents.find((x) => x.sfId === value);
    return e ? e.name : value;
  }
  if (field === "Amount") return formatAmount(value);
  if (field === "IsPrimary") return value ? "yes" : "no";
  if (field === "Description" || field === "Loss_Reason__c") return String(value).length > 140 ? `${String(value).slice(0, 140)}…` : String(value);
  if (field === "LinkedIn__c") return String(value).replace(/^https?:\/\/(www\.)?/, "");
  return String(value);
}

export default function ActionTimeline({ actions, meta }) {
  if (!actions || !actions.length) return <div className="ob-muted">No Salesforce actions planned.</div>;
  return (
    <ul className="ob-actions">
      {actions.map((a) => {
        const fields = Object.entries(a.fields || {}).filter(([k]) => !["Description"].includes(k) || OPP_MODIFY_TYPES.includes(a.type));
        return (
          <li key={a.key} className={`ob-action is-${a.status || "planned"}`}>
            <div className="ob-action__icon">
              <SfIcon kind={a.sobject} />
            </div>
            <div className="ob-action__body">
              <div className="ob-action__label">
                <span>{a.label}</span>
                <span className={`ob-pill ob-pill--sm ob-pill--${statusTone(a)}`}>{statusLabel(a)}</span>
              </div>
              {fields.length > 0 && (
                <div className="ob-action__fields">
                  {fields.map(([k, v]) => {
                    const shown = describeValue(k, v, meta);
                    if (!shown) return null;
                    return (
                      <span key={k}>
                        <b>{FIELD_LABELS[k] || k}:</b> {shown}
                      </span>
                    );
                  })}
                </div>
              )}
              {a.resultSfId && (
                <div style={{ marginTop: 4, fontSize: 12.5 }}>
                  <ExternalLink href={a.resultUrl}>Open {a.sobject === "OpportunityContactRole" ? "contact role" : a.sobject.toLowerCase()} in Salesforce</ExternalLink>
                </div>
              )}
              {a.error && <div className="ob-action__error">{a.error}</div>}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
